import { helper } from '@ember/component/helper';

import { classNames } from '../utils/style-utils';

const classNamesHelper = helper(function (params: (string | boolean | undefined | null)[]) {
  return classNames(params);
});

export default classNamesHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'class-names': typeof classNamesHelper;
  }
}
